module.exports = __webpack_public_path__ + "media/home-sparkle-bg-large.61860398.png";